import React, {Component} from 'react'
import reactCSS from 'reactcss'
import { SketchPicker, ChromePicker } from 'react-color'
import LinkWithTooltip from '../../tooltip';

class Color extends Component {

  constructor(props) {
    super(props);

    this.state = {
      displayColorPicker: false
    };
  }

  handleClick(){
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  }

  handleClose(){
    this.setState({ displayColorPicker: false })
  }

  handleChange(color){
    const { input: { onChange } } = this.props

    var mainColor = `rgba(${ color.rgb.r }, ${ color.rgb.g }, ${ color.rgb.b }, ${ color.rgb.a })`;

    if(color.rgb.a == 1){
      mainColor = color.hex;
    }
    onChange(mainColor);
  }

  handleChangeInput(e){
    const { input: { onChange } } = this.props

    onChange(e.target.value);
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.input.value !== this.state.realColor) {
      this.setState({ realColor: nextProps.input.value });
    }
  }

  render() {

    const { input: { value, onChange }, params } = this.props

    const styles = reactCSS({
      'default': {
        wrapper:{
          position: 'relative',
          padding: '3px 0'
        },
        colorContainer: {
          display: 'inline-block',
          backgroundImage: `url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAH5JREFUWAntlUsKACEMQ6vMjXr/I/RMOmtdBuRR0mWxGPIhY/0Tx1TVsYnIzGv34t28foUtDFAVBM/g98LoSsDwDBpg+5AMN4mosUMiEhh4Bt0k7SXGexAP0E3ikKgMqPf4kLhJ2kuM9yAeoJvEIVEZUO/xIXGTtJcY70E8wA3sHG3hUj6LrAAAAABJRU5ErkJggg==')`,
          borderRadius: '2px',
          border: '1px solid #eff1f4'
        },
        color: {
          width: '32px',
          height: '16px',
          borderRadius: '2px',
          backgroundColor: `${ value }`,
        },
        swatch: {
          position: 'relative',
          height: '28px',
          padding: '5px',
          background: '#fff',
          borderRadius: '2px',
          display: 'block',
          cursor: 'pointer',
          boxShadow: '0 0 10px 0 rgba(109,120,131,0.10)'
        },
        input: {
          position: 'absolute',
          top: '0px',
          left: '44px',
          border: 'none',
          boxShadow: 'none',
          zIndex: '2',
          width: 'calc(100% - 44px)',
          height: '28px'
        },
        popover: {
          //position: 'absolute',
          zIndex: '2',
          marginTop: '0px'
        },
        cover: {
          position: 'fixed',
          top: '0px',
          right: '0px',
          bottom: '0px',
          left: '0px',
        },
      },
    });

    if(this.state.displayColorPicker){
      styles.swatch.borderBottomColor = '#fff'
    }

    return (
      <div className="sp-pagebuilder-form-group" style={ styles.wrapper }>
        <label>
          { params.title }
          {
            typeof params.desc != 'undefined' && params.desc != '' &&
            <LinkWithTooltip tooltip={params.desc} position="top" title={params.title}>
              <i className="fa fa-question-circle" />
            </LinkWithTooltip>
          }
        </label>
        <div className="sppb-color-input" style={ styles.swatch }>
          <div style={styles.colorContainer} onClick={ this.handleClick.bind(this) }><div style={ styles.color } /></div>
          <input style={ styles.input } className="sp-pagebuilder-form-control" type="text" value={value} onChange={this.handleChangeInput.bind(this)} onClick={ this.handleClick.bind(this) } />
          {
            value != '' &&
            <div className="sppb-color-clear" onClick={e => {
              e.preventDefault()

              onChange('')
            }}><i className="fa fa-times" /></div>
          }
        </div>
        { this.state.displayColorPicker ?
          <div style={ styles.popover } className="clearfix">
            <div style={ styles.cover } onClick={ this.handleClose.bind(this) }/>
            <ChromePicker color={ value } onChange={ this.handleChange.bind(this) } />
          </div>
          : null
        }

      </div>
    )
  }
}

export default Color;



// WEBPACK FOOTER //
// ./src/helpers/form/types/Color.js